import {
  RecommendationArticleCard,
  RecommendationPosterCard,
} from "./components";
import { TRecommendationItemCardProps } from "./types";

export default function RecommendationItemCard({
  render = "poster",
  ...props
}: TRecommendationItemCardProps) {
  switch (render) {
    case "poster":
    case "portrait":
      return <RecommendationPosterCard {...props} render={render} />;

    case "article":
      return <RecommendationArticleCard {...props} />;

    default:
      return null;
  }
}
